import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockDisplayHeader, blockSettings, customizedBlock } from 'venn-state';
import { BenchmarkType } from '../../components/secondary/benchmark-type';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import { Block } from '../../components/core';
import { useFinancialPerformanceIndicatorsData } from './logic/useFinancialPerformanceIndicatorsData';
import { AsOfDate } from '../../components/secondary/as-of-date';
import { getDateBehavior } from 'venn-utils';
import { HoldingsCalculationInfo } from '../../components/secondary/holdings-calculation-info';

export const FinancialPerformanceIndicatorsHeader = ({ id }: { id: string }) => {
  const { subHeader } = useRecoilValue(customizedBlock(id));
  const title = useRecoilValue(blockDisplayHeader(id));
  const blockSetting = useRecoilValue(blockSettings(id));
  const data = useFinancialPerformanceIndicatorsData(id);
  const dateBehavior = getDateBehavior(blockSetting.customBlockType);

  const hasNegativeAssets = (data?.hasNegativeAssets ?? []).includes(true);

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>
        <Block.Metadata id={id}>
          <BenchmarkType id={id} />
          <AsOfDate holdingsData={data} dateBehavior={dateBehavior} />
          {hasNegativeAssets && <HoldingsCalculationInfo breakdownType="Long Rescaled Values" />}
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} relativeToBenchmark={false} />
    </>
  );
};
